// extracted by mini-css-extract-plugin
export var dividerLine = "_85-3";
export var itemImage = "_85-9";
export var lightDivider = "_85-4";
export var modalContent = "_85-5";
export var modalContentCompact = "_85-6";
export var productCard = "_85-a";
export var productImage = "_85-b";
export var productImageCompact = "_85-7";
export var productImagePlaceholder = "_85-c";
export var productImagePlaceholderCompact = "_85-8";
export var progressBarBackground = "_85-1";
export var progressBarContainer = "_85-0";
export var progressBarFill = "_85-2";